/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Layout from '_Layouts/Layout';
import EindexPathContainer from 'Routes/_Containers/CustomerJourneyViewGeneric/_Containers/EindexPath/EindexPathContainer';
import QLoginRedirect from '_Components/Auth/QLoginRedirect';
import { connect } from 'react-redux';
import { get } from 'lodash';
import CustomerJourneyViewGeneric from '../../_Containers/CustomerJourneyViewGeneric/CustomerJourneyViewGeneric';

const thematic = 'moments';
const idpage = 'moments';
const title = 'Moments';
const body = <CustomerJourneyViewGeneric idpage={idpage} thematic={thematic} />;
const additionalSubHeader = (
  <EindexPathContainer idpage={idpage} thematic={thematic} />
);

const action = props => (
  <QLoginRedirect>
    <Layout
      body={body}
      additionalSubHeader={
        props.pageConfiguration &&
        props.pageConfiguration.defaultThematic !== null &&
        additionalSubHeader
      }
      {...props}
      title={title}
    />
  </QLoginRedirect>
);

const mapStateToProps = state => ({
  pageConfiguration: get(state, ['routes', 'pageConfiguration']),
});

export default connect(mapStateToProps)(action);
